// tiny slider documentation https://github.com/ganlanyuan/tiny-slider
//TODO remove initSliderLessItems - its identical to initSlider

var prodScroller = function () {  	
	const initSlider = (sid) =>{
		const container = document.getElementById(sid);
		showSlider(container);
	};
		
	const initSliderLessItems = (sid) =>{
		const container = document.getElementById(sid);
		showSlider(container);
	};
	
	const showSlider = (container) =>{
		const slider = container.querySelector('.Scroller');
		let tinySlider;
		if(slider){
			tinySlider = new tns({
				container: slider,
				mouseDrag: true,
				lazyload: true,
				prevButton: container.querySelector('.slider-prev'),
				nextButton: container.querySelector('.slider-next'),
				items: 1,
				gutter: 20,
				slideBy: "page",
				nav:false,
				loop: false,
				responsive: {
					1024:{
						items: 5
					},
					800: {
						items: 4
					},
					480: {
						items: 3
					}
				}
			});
			updateLiveRegion(slider);
		}
		return tinySlider; 
	};
	
	const initSliderOneItem = (sid) =>{
		const container = document.getElementById(sid);
		const slider = container.querySelector('.Scroller');
		let oneItem;
		if(slider){
			oneItem = new tns({
				container: slider,
				mouseDrag: true,
				lazyload: true,
				prevButton: container.querySelector('.slider-prev'),
				nextButton: container.querySelector('.slider-next'),
				items: 1,
				gutter: 20,
				slideBy: "page",
				nav:false,
				loop: false
			});
			updateLiveRegion(slider);			
		}
		return oneItem; 
	};
	
	const updateLiveRegion = (slider) =>{
		if(slider.parentNode.parentNode.previousElementSibling.classList.contains("tns-liveregion"))
			slider.parentNode.parentNode.previousElementSibling.setAttribute("role", "status");
	};
	
	return{
        	InitSlider: initSlider,
        	InitSliderLessItems: initSliderLessItems,
        	InitSliderOneItem: initSliderOneItem
	};
};